import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import hydroponics_shop_nft from "../../Assets/hydroponics_shop_nft.webp";
import hydroponics_shop_nft1 from "../../Assets/hydroponics_shop_nft1.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Nft_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Twisted Rope (Tensioning Rope)",
      price: 250,
      image: hydroponics_shop_nft,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_shop_nft}
                alt="nft"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_shop_nft1}
                alt="Nutrient film technique"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">NFT Hydroponic System</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  The NFT (Nutrient Film Technique) Hydroponic System is a
                  widely adopted, efficient, and space-saving method of growing
                  leafy greens and herbs. It uses a continuous flow of
                  nutrient-rich water over plant roots through flat channels,
                  ensuring optimal nutrient absorption and fast plant growth.
                </p>
                <i>Note: Minimum Order Quantity: 1 Set</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material:</span> Food-grade
                    UV-stabilized PVC channels
                  </li>
                  <li>
                    <span className="fw-bold">Channel Size:</span> 100mm x 50mm
                    (or customized)
                  </li>
                  <li>
                    <span className="fw-bold">Color:</span> White (to reflect
                    light and reduce heat buildup)
                  </li>
                  <li>
                    <span className="fw-bold">System type:</span> Recirculating
                    Nutrient Film Technique
                  </li>
                  <li>
                    <span className="fw-bold">Pump:</span>Submersible pump
                    included (optional)
                  </li>
                  <li>
                    <span className="fw-bold">Frame:</span> Galvanized Iron or
                    Stainless Steel (optional)
                  </li>
                  <li>
                    <span className="fw-bold">Installation type:</span>{" "}
                    Floor-mounted or A-frame
                  </li>
                  <li>
                    <span className="fw-bold">Brand:</span> RGCPL
                  </li>

                  <li>
                    <span className="fw-bold">Minimum Order Quantity:</span> 1
                    Set
                  </li>
                  <li>
                    <span className="fw-bold">Durability:</span> 4–5 Years (PVC
                    channel), 10+ Years (metal frame)
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Soil-less Cultivation: Clean, modern growing solution with
                    no mess
                  </li>
                  <li>
                    Water Efficient: Uses 90% less water than traditional
                    farming
                  </li>
                  <li>
                    Fast Growth: Promotes faster root development and nutrient
                    uptake
                  </li>
                  <li>
                    Modular Design: Expandable as per farm size or crop type
                  </li>
                  <li>Low Maintenance: Fewer components and easy to clean</li>
                  <li>
                    Compact & Productive: Best use of vertical or horizontal
                    space
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0034
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 50–100
                    Systems Per Month
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span> PVC
                    channels wrapped in protective film; frame in parts
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Importance of NFT Hydroponic System:</h5>
        <p className="text-justify">
          The NFT system is crucial for clean, fast, and efficient growth of
          leafy vegetables. It provides constant nutrient delivery with minimal
          resource use, making it perfect for urban, commercial, and rooftop
          farms.
        </p>

        <h5 className="mt-3">Key Benefits of NFT Hydroponic System:</h5>
        <ul>
          <li>Enhances productivity in limited space.</li>
          <li>Reduces pest/disease risk due to non-soil medium.</li>
          <li>Uniform delivery of nutrients to all plants.</li>
          <li>Reduces dependency on climate and weather conditions.</li>
        </ul>

        <h5 className="mt-3">Applications of NFT Hydroponic System:</h5>
        <ul>
          <li>Rooftop kitchen gardens and home setups.</li>
          <li>Commercial farms producing leafy greens for retail.</li>
          <li>Research and training centers in agriculture technology.</li>
          <li>Urban agriculture and vertical farming solutions.</li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Nft_shop;
